export const state = {
	notifications: [],
	open: false
}



// WEBPACK FOOTER //
// ./src/common/store/Notifications/state.js